/*
akhila  10/28/2022 3075154998 enable framework UX changes
 */
import React, {useState, useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddFilter from './AddFilter/AddFilter';
import SearchFilter from './SearchFilter';
import {Card} from '@material-ui/core';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import FilterUsage from './Usage';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'padding': {
    padding: '40px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
  'searchRuleButton': {
    margin: '-8px 0 8px',
  },
}));

export default function FilterSubTabs() {
  const classes1 = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [valueCode, setValueCode] = useState(0);
  const [filterCode, setFilterCode] = useState(null);
  const [filterCodeName, setFilterCodeName] = useState('');
  const [isCopyRowData, setIsCopyRowData] = useState(false);
  const [fieldRowData, setFieldRowData] = useState('');

  return (
    <Card className={` ${classes.cardBordernoneStyles} mb-0`} elevation={0}>
      <div className={classes1.root}>
        <Typography />
        <div className={classes.subContent}>
          {valueCode === 0 ? (
            <SearchFilter
              setValueCode={setValueCode}
              valueCode={valueCode}
              setFilterCode={setFilterCode}
              setFilterCodeName={setFilterCodeName}
              setIsCopyRowData={setIsCopyRowData}
              fieldRowData={fieldRowData}
              setFieldRowData={setFieldRowData}
            />
          ) :
            valueCode === 1 ? (
              <AddFilter
                setValueCode={setValueCode}
                valueCode={setValueCode}
                filterCode={filterCode}
                setFilterCode={setFilterCode}
                filterCodeName={filterCodeName}
                setFilterCodeName={setFilterCodeName}
                isCopyRowData={isCopyRowData}
              />
            ) :
              valueCode === 2 ? (
                <FilterUsage setValueCode={setValueCode} />
              ) : null }
        </div>
      </div>
    </Card>
  );
}
